/** Generic6DOFJoint3D property surface. A key stays `undefined` when unauthored, so the consumer applies Godot's default. */
/** The limits of one axis the gizmo draws: each authored key, else Godot's default. */
function drawnAxisLimits(properties, axis) {
    return {
        linearEnabled: properties[`linear_limit_${axis}/enabled`] ?? true,
        linearLower: properties[`linear_limit_${axis}/lower_distance`] ?? 0,
        linearUpper: properties[`linear_limit_${axis}/upper_distance`] ?? 0,
        angularEnabled: properties[`angular_limit_${axis}/enabled`] ?? true,
        angularLower: properties[`angular_limit_${axis}/lower_angle`] ?? 0,
        angularUpper: properties[`angular_limit_${axis}/upper_angle`] ?? 0,
    };
}
export function drawnLimits(properties) {
    return [
        drawnAxisLimits(properties, 'x'),
        drawnAxisLimits(properties, 'y'),
        drawnAxisLimits(properties, 'z'),
    ];
}
function sameAxis(a, b) {
    return (a.linearEnabled === b.linearEnabled &&
        a.linearLower === b.linearLower &&
        a.linearUpper === b.linearUpper &&
        a.angularEnabled === b.angularEnabled &&
        a.angularLower === b.angularLower &&
        a.angularUpper === b.angularUpper);
}
/** Whether two limit sets hold the same values. */
export function sameLimits(a, b) {
    return sameAxis(a[0], b[0]) && sameAxis(a[1], b[1]) && sameAxis(a[2], b[2]);
}
//# sourceMappingURL=types.js.map